import { Select } from "antd";
import { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
const { Option } = Select;

const Type = ["course", "landing-page"];

const Information = ({
  title,
  handleSubmit,
  editorContent,
  handleEditorChange,
  handleExportPDF,
  setSelectedType,
  selectedType,
}) => {
  const [value, setValue] = useState(editorContent);
  const [isEditing, setIsEditing] = useState(false);
  const quillRef = useRef(null);

  useEffect(() => {
    if (editorContent && editorContent !== value) {
      setValue(editorContent);
    }
  }, [editorContent, value]);

  const onEditorChange = (content) => {
    const quill = quillRef.current?.getEditor();
    if (quill) {
      const delta = quill.getContents();
      setValue(delta);
      handleEditorChange(content);
    }
  };

  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    ["link", "image", "video", "formula"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
  ];

  return (
    <div className="bg-card overflow-hidden shadow rounded-2xl h-full border border-border">
      <div className="p-4">
        <div className="flex flex-row items-center justify-between">
          <h2 className="text-2xl font-semibold capitalize text-primary">
            {title}
          </h2>
          <section className="flex flex-nowrap gap-5 ">
            {
              selectedType && (
                <Select
                  value={selectedType}
                  onChange={(value) => {
                    setSelectedType(value);
                    setValue("");
                  }}
                >
                  {Type.map((type, index) => (
                    <Option key={index} value={type}>
                      {" "}
                      <span className="capitalize">{type}</span>
                    </Option>
                  ))}
                </Select>
              )
            }

            <button
              onClick={() => setIsEditing(!isEditing)}
              className={`rounded-xl px-5 py-1 text-md text-center uppercase text-white ${isEditing ? "bg-red-500" : "bg-primary"
                } hover:bg-opacity-90`}
            >
              <p className="font-medium">{isEditing ? "Cancel" : "Edit"}</p>
            </button>
          </section>
          {/* <button
            onClick={handleExportPDF}
            className="space-x-2 rounded-xl px-10 py-2 text-md text-center uppercase text-white bg-orange-500 hover:bg-opacity-90"
          >
            <p className="font-medium">Export PDF</p>
          </button> */}
        </div>
        <div className="h-[calc(100vh-250px)] mt-3">
          <ReactQuill
            ref={quillRef}
            theme="snow"
            placeholder="Write Content here..."
            value={value}
            onChange={onEditorChange}
            modules={{ toolbar: toolbarOptions }}
            className="h-full"
            readOnly={!isEditing}
          />
        </div>
      </div>
      {isEditing && (
        <div className="flex items-center justify-center mt-3">
          <button
            onClick={handleSubmit}
            className="rounded-xl px-10 py-2 text-md text-center uppercase text-white bg-primary hover:bg-opacity-90"
          >
            <p className="font-medium">Save</p>
          </button>
        </div>
      )}
    </div>
  );
};

export default Information;
